import { render, staticRenderFns } from "./LobbyPhase.vue?vue&type=template&id=a8bfdadc&"
import script from "./LobbyPhase.vue?vue&type=script&lang=js&"
export * from "./LobbyPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports